module.exports = __webpack_public_path__ + "static/media/ic-order.84d49dda.svg";